import { useEffect } from 'react';

import { useContextCurrency, useContextRouting } from '@core/context';
import { ECurrency } from '@core/type';

export const useChartsCurrencyUpdate = () => {
  const { currency, changeCurrency } = useContextCurrency();
  const { query } = useContextRouting();

  useEffect(() => {
    const urlCurrency = (
      query as unknown as {
        slug: string[];
      }
    )?.slug?.[0]?.toUpperCase() as ECurrency;

    if (Object.values(ECurrency).includes(urlCurrency) && urlCurrency !== currency) {
      changeCurrency(urlCurrency);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query?.slug?.[0]]);
};
